// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1494":"8462dff6","2410":"8462dff6","4163":"98724c4e","4873":"4d8d69d2","9776":"8462dff6"}[chunkId] + ".chunk.css";
};